import React from "react";
import { Lock } from "lucide-react";
import { getStoredUser } from "../lib/api";
import AuthForm from "./AuthForm";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

export const GuestLock = ({ guest, className = "w-3.5 h-3.5" }) =>
  (guest ?? getStoredUser()?.is_guest) ? <Lock data-testid="coins-locked-icon" className={`${className} text-[#38BDF8]`} aria-label="Locked until sign up" /> : null;

export const GuestUnlockModal = ({ open, onClose, onAuthed, coins }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="guest-unlock-modal" aria-describedby={undefined} className="theme-light w-[calc(100%-2rem)] bg-transparent border-0 p-0 max-w-sm shadow-none">
      <DialogTitle className="sr-only">Sign up to unlock your balance</DialogTitle>
      <AuthForm
        onAuthed={(u) => { onAuthed?.(u); onClose(); }}
        title={`Sign up to unlock your £${coins ?? 40}`}
        subtitle="Your virtual £ is locked while you play as a guest. Create a free account to stake it, spin the wheel and keep your winnings."
      />
    </DialogContent>
  </Dialog>
);
